// SPDX-FileCopyrightText: Copyright 2025 Dash0 Inc.

import { Tag } from "@/components/ui/tag";
import { cn } from "@/lib/utils";

export function BetaTag({ className }: { className?: string }) {
  return (
    <Tag
      className={cn(
        "inline-flex grow-0 items-center rounded h-5 px-1.5 text-xs font-normal leading-4 text-white",
        "bg-[image:linear-gradient(107deg,#EA3D3B_38.16%,#F56B71_69.43%,#F88E66_106.06%)]",
        className
      )}
    >
      BETA
    </Tag>
  );
}
